import {
  Box,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { setAuthStatus } from "../../store/actions/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useRequest } from "../../api/utils/useRequest";
import { BalootUserV2APIs } from "../../api/APIs";
import { useState } from "react";
import { useSnackBar } from "../../context/SnackBarContext";
import AuthStatusBox from "../../components/auth/AuthStatusBox";
import { LoadingButton } from "@mui/lab";
import { isNationalIdValid } from "../../utils/validations";
import { CancelOutlined } from "@mui/icons-material";
import CheckValidRow from "../../components/shared/CheckValidRow";
import { removeNonNumeric } from "../../utils/Utils";

function NationalIdPage() {
  const openSnack = useSnackBar();
  const [nationalId, setNationalId] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authStatusMessage = useSelector(
    (state) => state.auth.authStatusMessage
  );

  const { apiCall: sejamStatusCheck, loading: sejamLoading } = useRequest(
    BalootUserV2APIs.sejamStatusCheck
  );
  const { apiCall: shahkarCheck, loading: shahkarLoading } = useRequest(
    BalootUserV2APIs.shahkarCheck
  );

  const handleSubmit = () => {
    sejamStatusCheck({
      data: { nationalId },
      onSuccess: (response) => {
        if (response.status === "AUTHENTICATED") {
          navigate("/auth/referral");
          dispatch(setAuthStatus({}));
        } else if (response.status === "OTP_SENT") {
          navigate("../sejam-otp-confirm", { state: { nationalId } });
          dispatch(setAuthStatus({}));
        } else {
          dispatch(setAuthStatus({ page: "SejamStatus", data: response }));
          navigate("../sejam-status");
        }
      },
      onError: (error) => {
        if (error.data?.errorKey === "sejamInvalidStatus") {
          dispatch(setAuthStatus({ page: "NationalId" }));
        } else {
          openSnack(true, { message: error.message });
        }
      },
    });
  };

  const proceedWithShahkar = () => {
    shahkarCheck({
      data: { nationalId },
      onSuccess: (response) => {
        if (response.verified) {
          navigate("../personal-info/first-name");
          dispatch(setAuthStatus({}));
        } else {
          dispatch(setAuthStatus({ page: "NationalId", data: response }));
        }
      },
    });
  };

  return (
    <>
      <AppBarContainer
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            ساخت حساب بلوط
          </Typography>
        }
      />
      <PageContentContainer sx={{ overflow: "auto" }}>
        <Box>
          <Typography component={"div"}>
            <Box
              display={"inline"}
              sx={{ typography: "body2", color: "grey.2" }}
            >
              کد ملی
            </Box>{" "}
            <Box
              display={"inline"}
              sx={{ typography: "subtitle1", color: "grey.4" }}
            >
              (مطابق کارت ملی)
            </Box>
          </Typography>
          <TextField
            name="nationalId"
            inputProps={{
              inputMode: "numeric",
            }}
            error={nationalId.length === 10 && !isNationalIdValid(nationalId)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {nationalId.length > 0 && (
                    <IconButton
                      onClick={() => {
                        setNationalId("");
                      }}
                    >
                      <CancelOutlined sx={{ fontSize: 20 }} />
                    </IconButton>
                  )}
                </InputAdornment>
              ),
            }}
            sx={{ mt: "12px" }}
            fullWidth
            placeholder="کد ملی خود را وارد نمایید"
            value={nationalId}
            onChange={(event) => {
              if (event.target.value === null) {
                setNationalId("");
              } else {
                event.target.value.length < 11 &&
                  setNationalId(removeNonNumeric(event.target.value));
              }
            }}
          />
          <CheckValidRow
            sx={{ my: "2px", mt: 2 }}
            isValid={isNationalIdValid(nationalId)}
            title="کد ملی معتبر"
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <Box>
            {authStatusMessage.page === "NationalId" && (
              <AuthStatusBox
                loading={shahkarLoading}
                title={
                  authStatusMessage.data?.message?.title || "خطا در سرویس سجام"
                }
                body={
                  authStatusMessage.data?.message?.body ||
                  "سرویس سجام در حال حاضر در دسترس نیست. اگر تمایل دارید فرآیند ثبت نام را به صورت عادی ادامه دهید."
                }
                buttonTitle={
                  authStatusMessage.data
                    ? "تغییر شماره موبایل"
                    : "ثبت‌نام به صورت عادی"
                }
                buttonAction={
                  authStatusMessage.data
                    ? () => {
                        navigate("/auth/register");
                        dispatch(setAuthStatus({}));
                      }
                    : () => {
                        navigate("/auth/personal-info/first-name");
                        dispatch(setAuthStatus({}));
                      }
                }
              />
            )}
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <LoadingButton
                onClick={handleSubmit}
                loading={sejamLoading}
                disabled={!isNationalIdValid(nationalId)}
                variant="contained"
                color="primary"
                sx={{ height: 56, width: 48 }}
              >
                <ArrowBackIcon sx={{ color: "common.white", fontSize: 24 }} />
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </PageContentContainer>
    </>
  );
}

export default NationalIdPage;
